import type {
  Evidence,
  LogEvidence,
  EvidenceType,
} from 'security-app/components/Investigations/Details/TimelineSegment/types';
import { evidenceTypeLog } from 'security-app/components/Investigations/Details/TimelineSegment/Constants';

const isLogEvidenceType = (evidenceType: EvidenceType) => evidenceType === evidenceTypeLog;

export const removeIlluminateEventDefinitionPrefix = (eventDefinitionTitle: string) =>
  eventDefinitionTitle?.replace(/^Illuminate:Events:\d+[:;]/, '');
export const isLogEvidence = (evidence: Evidence): evidence is LogEvidence => isLogEvidenceType(evidence.type);

export const evidenceTypeLabel = (evidenceType: EvidenceType, lowercase = false) => {
  const label = isLogEvidenceType(evidenceType) ? 'Message' : 'Event';

  if (lowercase) {
    return label.toLocaleLowerCase();
  }

  return label;
};
